import React from "react";
import HeaderContainer from "../Header/HeaderContainer";

import { Affix, Col, Grid, Layout, Row, Space, Typography } from "antd";
import BackBtn from "components/reusables/BackBtn/BackBtnComponent";
import NextStepBtnComponent from "components/reusables/NextStepBtn/NextStepBtnComponent";
import AccordionNavComponent from "components/reusables/AccordionNav/AccordionNavComponent";
import { AccordionNavComponentTypes } from "components/reusables/AccordionNav/AccordionNavComponent.types";
import StepFlowComponent from "components/reusables/StepFlow/StepFlowComponent";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import ButtonsNavComponent from "components/reusables/ButtonsNav/ButtonsNavComponent";
import InfoCarousel from "components/reusables/InfoCarousel/InfoCarouselComponent";
import NextBackBtnComponent from "components/reusables/NextBackBtn/NextBackBtnComponent";
import { IButtonsNavTypes } from "components/reusables/ButtonsNav/ButtonsNav.types";

const { Title } = Typography;
const { useBreakpoint } = Grid;

/* Accordion Content images */
//first accordion vehicleInfo
import docSign from "../../../assets/namespace/img/9_firma.png";
import contractSummary from "../../../assets/namespace/img/10_resumen_tramitacion_contrato.webp";
import docSignLg from "../../../assets/namespace/img/9_firma_lg.png";
import contractSummaryLg from "../../../assets/namespace/img/10_resumen_tramitacion_contrato_lg.webp";
import TextHeaderComponent from "components/reusables/TexlHeader/TextHeaderComponent";
/* end content images */

const documentSign = () => (
  <div>
    <div className="contentLabel">
      Comprador y vendedor reciben un email para continuar el proceso de firma,
      el que ha sido diseñado para ser fácil y seguro usando un dispositivo.
    </div>
    <InfoCarousel items={[docSign]} />
  </div>
);

const documentProcessing = () => (
  <div>
    <div className="contentLabel">
      Al pagar impuestos y aranceles el documento queda autorizado legalmente y
      es ingresado a la institución oficial, dando paso al acuerdo del pago de
      la venta y entrega del vehículo.
    </div>
    <InfoCarousel items={[contractSummary]} />
  </div>
);

const TabsInfo: IButtonsNavTypes = {
  TabsContent: [
    {
      title: 'Firma de documentos',
      slug: 'document-sign',
      text: "Comprador y vendedor reciben un email para continuar el proceso de firma, el que ha sido diseñado para ser fácil y seguro usando un dispositivo.",
      contentImg: docSignLg

    },
    {
      title: 'Tramitación de contrato',
      slug: 'contract',
      text: "Al pagar impuestos y aranceles el documento queda autorizado legalmente y es ingresado a la institución oficial, dando paso al acuerdo del pago de la venta y entrega del vehículo.",
      contentImg: contractSummaryLg,
    }
  ],
};

const AvailableInfo: AccordionNavComponentTypes = {
  AvailableContent: [
    {
      title: "Firma de documentos",
      slug: "document-sign",
      content: documentSign(),
    },
    {
      title: "Tramitación de contrato",
      slug: "document-processing",
      content: documentProcessing(),
    },
  ],
};

function DocumentPaySignContainer() {
  const screens = useBreakpoint();
  return (
    <div id="container">
      <Layout id="body">
        <Space direction="vertical" size={35}>
          <HeaderContainer />
          <Layout
            style={{
              padding: "1rem",
              alignItems: "center",
              maxWidth: "1140px",
              margin: "auto",
            }}
          >
            <TextHeaderComponent />
            <StepFlowComponent current={2} className={""}></StepFlowComponent>
            <Row style={{ justifyContent: "center" }}>
              <Col xs={24} md={20} style={{ maxWidth: "1024px" }}>
                <Space size={24} direction="vertical">
                  <div>
                    {/* TODO: move to component */}
                    <Row style={{ paddingTop: `${!screens["lg"] ? '5px' : '20px'}`, justifyContent: 'center' }}>
                      <Col style={{ maxWidth: '630px' }}>
                        <Space size={16} direction="vertical">
                          <Col span={24} >
                            <Title
                              className={"body-text-header"}
                              style={{
                                textAlign: "center"
                              }}
                            >
                              Pago y firma de documento
                            </Title>
                          </Col>
                          <Row>
                            <div>
                              <Title
                                className={"vehicle-buy-text-description"}
                                level={4}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  En Autofact registramos todos los
                                  antecedentes para que las firmas de los
                                  documentos y contrato sean
                                  autorizadas.&nbsp;
                                </span>

                                <span style={{ fontWeight: "700" }}>
                                  La toma digital de firmas puede
                                  realizarse cualquier día y hora.
                                </span>
                                <br />
                                <br />
                                <span style={{ fontWeight: "700", display: screens.md ? 'inline-block' : 'none' }} >
                                  {" "}
                                  Recuerda, aquí exponemos el proceso de
                                  Transferencia a modo de ejemplo.
                                </span>
                              </Title>
                            </div>
                          </Row>
                        </Space>
                      </Col>
                    </Row>
                    {/* end move to component */}
                  </div>
                  <div style={{ alignItems: "center" }}>
                    {!screens["lg"] ? (
                      <AccordionNavComponent
                        AvailableContent={AvailableInfo.AvailableContent}
                      />
                    ) : (
                      <ButtonsNavComponent TabsContent={TabsInfo.TabsContent} className={"tabsPushToCenter"} />
                    )}
                  </div>
                </Space>
                <Row style={{ justifyContent: "end" }}>
                  <Col md={12} xs={0}>
                    <NextBackBtnComponent
                      id='simTrf-step4-congratulations'
                      value={`/opciones/transferencia-lista`}
                      rowClassName="rowClassName"
                    ></NextBackBtnComponent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </Space>
      </Layout>
      <Affix offsetBottom={1}>
        <div
          id="fix-mobile-footer"
          className="mobileStyle"
        >
          <Row justify="center" align="middle" style={{ padding: "1rem" }}>
            <Col style={{ width: "50%" }}>
              <BackBtn label={"Volver"} title="Volver atrás"></BackBtn>
            </Col>
            <Col style={{ width: "50%" }}>
              <NextStepBtnComponent
                id='simTrf-step4-congratulations'
                value={`/opciones/transferencia-lista`}
                text={"Siguiente"}
                action={() => {
                  alert("Clicked");
                }}
              />
            </Col>
          </Row>
        </div>
      </Affix>
      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </div>
  );
}

export default DocumentPaySignContainer;
